import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { IgComment, IgUser } from '@core/models/ApiFields/ig-entities';
import { Paginated, ResDataItem } from '@core/models/IApi';
import {
    IG_ENDPOINT,
    postUsersParams,
} from '@features/social-analysis/social-listening/config/api-params';
import { BaseState, DATA_STATUS } from '@features/social-analysis/social-shared/store/state.store';
import { HttpBuilder } from '../../social-shared/services/http/http-builder';
import { SingleHttpSubscription } from '../../social-shared/services/http/http-subscription';
import { PostUser } from '../models/I-user';

@Injectable({ providedIn: 'root' })
export class PostUsersHttpBuilder extends HttpBuilder {
    #subsHandler = new SingleHttpSubscription();

    reqUsers(state: BaseState<PostUser>, mediaId: string) {
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.buildParams(mediaId);

        state.isLoading.set(true);
        state.data.set([]);

        const http = this.http.get<Paginated>(url, { params });
        const sub = this.subscribeToHttp$(http, state);
        this.#subsHandler.httpSub = sub;
    }

    private buildParams(mediaId: string): Params {
        return {
            ...this.getFields(),
            ...this.getSort(),
            ...this.getLimit(),
            ...this.getMediaIdFilter(mediaId),
        };
    }

    private getFields() {
        return { fields: postUsersParams.fields.join() };
    }

    private getMediaIdFilter(mediaId: string) {
        return { [IgComment.getPrefixed('mediaId')]: 'eq:' + mediaId };
    }

    private getSort() {
        return { sort: postUsersParams.sort.join() };
    }

    private getLimit() {
        return { limit: postUsersParams.limit };
    }

    protected override handleSuccess(state: any, data: ResDataItem[]) {
        state.data.set(data.map(item => this.formatItem(item)));
        state.dataStatus.set(DATA_STATUS.OK);
    }

    private formatItem(item: ResDataItem) {
        return new PostUser(
            item[IgUser.getPrefixed('image')],
            item[IgUser.getPrefixed('username')],
            item[IgUser.getPrefixed('influencer')],
            item[IgUser.getPrefixed('level')],
            item[IgComment.getPrefixed('likes')],
            item[IgComment.getPrefixed('commentsCount')]
        );
    }
}
